/**
 * UI Components Module - Specific widgets and small UI logic
 */

/**
 * Setup Clock, Weather and Countdown widgets
 * @returns {void}
 */
export function setupLiveWidgets() {
  const horaEl = document.getElementById('widget-hora');

  // 1. Clock
  const updateClock = () => {
    if (!horaEl) return;
    const now = new Date();
    const dateStr = now.toLocaleDateString('es-PY', { weekday: 'short', day: 'numeric', month: 'short' });
    const timeStr = now.toLocaleTimeString('es-PY', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    horaEl.innerHTML = `<i class="far fa-calendar-alt"></i> <span>${dateStr}</span> <span style="opacity: 0.3; margin: 0 5px;">|</span> <i class="far fa-clock"></i> <strong>${timeStr}</strong>`;
  };
  setInterval(updateClock, 1000);
  updateClock();
}
